import React from 'react';

import Button, { Props } from '../Button';

export type PrimaryButtonProps = Props;

function PrimaryButton(
  { color = 'primary', ...props }: PrimaryButtonProps,
  ref: Props['ref'],
) {
  return <Button {...props} ref={ref} color={color} />;
}

export default React.forwardRef(PrimaryButton);
